var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "q-form",
            { ref: "editForm" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBL0001065", collapsed: true },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: false,
                            disabled: true,
                            label: "팀명(반)",
                            name: "assessDeptName",
                          },
                          model: {
                            value: _vm.process.assessDeptName,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "assessDeptName", $$v)
                            },
                            expression: "process.assessDeptName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: false,
                            disabled: true,
                            label: "공정명",
                            name: "processName",
                          },
                          model: {
                            value: _vm.process.processName,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "processName", $$v)
                            },
                            expression: "process.processName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: false,
                            disabled: true,
                            label: "원(재)료",
                            name: "mainMaterial",
                          },
                          model: {
                            value: _vm.process.mainMaterial,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "mainMaterial", $$v)
                            },
                            expression: "process.mainMaterial",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: false,
                            disabled: true,
                            type: "number",
                            label: "근로자수(명)",
                            name: "workerCnt",
                          },
                          model: {
                            value: _vm.process.workerCnt,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "workerCnt", $$v)
                            },
                            expression: "process.workerCnt",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: false,
                            disabled: true,
                            label: "생산품(기종)",
                            name: "productName",
                          },
                          model: {
                            value: _vm.process.productName,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "productName", $$v)
                            },
                            expression: "process.productName",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "기타 안전보건상 정보", collapsed: true },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-accident", {
                          attrs: {
                            editable: _vm.editable,
                            multiple: "",
                            disabled: true,
                            label: "최근 3년간 재해발생사례",
                            name: "accidentHistoryDesc",
                          },
                          model: {
                            value: _vm.process.accidentHistoryDesc,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "accidentHistoryDesc", $$v)
                            },
                            expression: "process.accidentHistoryDesc",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-accident", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            isNear: true,
                            multiple: "",
                            label: "아차사고사례",
                            name: "nearMissDesc",
                          },
                          model: {
                            value: _vm.process.nearMissDesc,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "nearMissDesc", $$v)
                            },
                            expression: "process.nearMissDesc",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6" },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            codeGroupCd: "MDM_PROCESS_WORKER_TYPE_CD",
                            disabled: true,
                            isArray: false,
                            label: "근로자 구성 및 경력특성",
                            name: "workerTypeCd",
                            itemText: "codeName",
                            itemValue: "code",
                          },
                          model: {
                            value: _vm.process.workerTypeCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "workerTypeCd", $$v)
                            },
                            expression: "process.workerTypeCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            codeGroupCd: "MDM_PROCESS_TRANSPORT_TYPE_CD",
                            type: "edit",
                            disabled: true,
                            isArray: false,
                            itemText: "codeName",
                            itemValue: "code",
                            name: "heavyTransportTypeCd",
                            label: "중량물 운반수단",
                          },
                          model: {
                            value: _vm.process.heavyTransportTypeCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "heavyTransportTypeCd", $$v)
                            },
                            expression: "process.heavyTransportTypeCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-4" },
                      [
                        _c("c-text", {
                          attrs: {
                            disabled: true,
                            editable: _vm.editable,
                            label: "장비명",
                            name: "heavyTransportEquip",
                          },
                          model: {
                            value: _vm.process.heavyTransportEquip,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "heavyTransportEquip", $$v)
                            },
                            expression: "process.heavyTransportEquip",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            isFlag: true,
                            label: "교대작업 유무",
                            name: "shiftFlag",
                          },
                          model: {
                            value: _vm.process.shiftFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "shiftFlag", $$v)
                            },
                            expression: "process.shiftFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            isFlag: true,
                            label: "중량물 인력취급유무",
                            name: "heavyManualFlag",
                          },
                          model: {
                            value: _vm.process.heavyManualFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "heavyManualFlag", $$v)
                            },
                            expression: "process.heavyManualFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            codeGroupCd: "MDM_PROCESS_HANDLING_TYPE_CD",
                            type: "edit",
                            itemText: "codeName",
                            disabled: true,
                            isArray: false,
                            itemValue: "code",
                            name: "heavyManualTypeCd",
                            label: "취급형태(들기/밀기/끌기)",
                          },
                          model: {
                            value: _vm.process.heavyManualTypeCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "heavyManualTypeCd", $$v)
                            },
                            expression: "process.heavyManualTypeCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            isFlag: true,
                            label: "작업환경측정 실시",
                            name: "workEnvMeasureFlag",
                          },
                          model: {
                            value: _vm.process.workEnvMeasureFlag,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "workEnvMeasureFlag", $$v)
                            },
                            expression: "process.workEnvMeasureFlag",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-text", {
                          attrs: {
                            disabled: true,
                            editable: _vm.editable,
                            label: "노출초과인자/수치",
                            name: "exposureOverValue",
                          },
                          model: {
                            value: _vm.process.exposureOverValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "exposureOverValue", $$v)
                            },
                            expression: "process.exposureOverValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-checkbox", {
                          attrs: {
                            editable: _vm.editable,
                            codeGroupCd:
                              "RAM_RISK_PROCESS_SPECIAL_EDU_TARGET_CD",
                            type: "edit",
                            disabled: true,
                            isArray: false,
                            itemText: "codeName",
                            itemValue: "code",
                            name: "specialEduTargetCd",
                            label: "특별안전보건교육 해당",
                          },
                          model: {
                            value: _vm.process.specialEduTargetCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.process, "specialEduTargetCd", $$v)
                            },
                            expression: "process.specialEduTargetCd",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
              _c(_vm.subComponent, {
                tag: "component",
                attrs: {
                  process: _vm.process,
                  assessPlan: _vm.assessPlan,
                  disabled: _vm.disabled,
                  updateBtnData: _vm.updateBtnData,
                  vendorFlag: _vm.vendorFlag,
                },
                on: {
                  "update:process": function ($event) {
                    _vm.process = $event
                  },
                  "update:assessPlan": function ($event) {
                    _vm.assessPlan = $event
                  },
                  "update:assess-plan": function ($event) {
                    _vm.assessPlan = $event
                  },
                  "update:disabled": function ($event) {
                    _vm.disabled = $event
                  },
                  "update:updateBtnData": function ($event) {
                    _vm.updateBtnData = $event
                  },
                  "update:update-btn-data": function ($event) {
                    _vm.updateBtnData = $event
                  },
                  "update:vendorFlag": function ($event) {
                    _vm.vendorFlag = $event
                  },
                  "update:vendor-flag": function ($event) {
                    _vm.vendorFlag = $event
                  },
                  saveProcess: _vm.emitSaveProcess,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }